<template>
  <div class="filter-search" ref="filter-search" :style="{width: show ? '200px' : '24px'}">
    <i class="icon iconfont iconicon_search1 tableIconHover" @click="showInput"></i>
    <el-input ref="input" v-model="currentVal" clearable :placeholder="placeholder || '搜索任务名称'" v-if="show" @blur="blur" @clear="clear"></el-input>
  </div>
</template>
<script>
export default {
  props:['value', 'placeholder'],
  data() {
    return {
      show: false
    }
  },
  computed: {
    currentVal:{
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    showInput() {
      if(this.show) return
      this.show = true
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    clear() {
      this.show = false
    },
    blur() {
      if(this.currentVal === '') {
        this.show = false
      }
    },
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.filter-search {
  display: flex;
  align-items: center;
  transition: all .3s;
  width: 24px;
  i {
    @include fontColorOpacity(.6);
  }
  .el-input__inner {
    border: 0 none !important;
    padding-left: 8px;
    &:hover, &:focus {
      border: 0 none !important;
    }
  }
}
</style>
